import Icons from "../../../../utils/icons";

// Define the types for actions and icons
export const EMPLOYEE_ACTIONS = {
  Edit: "Edit",
  // View: "View",
} as const; // `as const` makes the object readonly and infers the types for each key

// Define the type for the action icons
export const EMPLOYEE_ACTIONS_ICONS: any = {
  View: Icons.RemoveRedEye,
  // Edit: Icons.Edit,
};

// Define the types for headers
type Header = {
  key: string;
  label: string;
  sortable?: boolean;
  items?: { [key: string]: JSX.Element }; // Correct the items type to a record of JSX elements (icons)
  style?: React.CSSProperties;
  isNumeric?: boolean;
};

// Define the structure of the USER_HEADERS constant as an array directly
export const ACTIVITY_CASE_HEADERS: Header[] = [
  {
    key: "sourceType",
    label: "Type",

    style: { width: "8%" },
  },
  // {
  //   key: "stageType",
  //   label: "Stage",

  //   style: { width: "10%" },
  // },
  // {
  //   key: "activityDescription",
  //   label: "Activity Code / Description ",

  //   style: { width: "27%" },
  // },
  {
    key: "stageType",
    label: "Stage / Activity Code - Description",
    style: { width: "35%" },
  },
  {
    key: "fileCount",
    label: "File",

    style: { width: "8%" },
  },
  {
    key: "addedBy",
    label: "Added By",

    style: { width: "15%" },
  },
  { key: "transactionDate", label: "Date", style: { width: "8%" } },
  {
    key: "transactionTime",
    label: "Time",
    style: { width: "8%" },
  },
  {
    key: "elapsedTime",
    label: "Elapsed Time",
    style: { width: "8%" },
  },
];

export const NOTE_FILE_HEADERS: Header[] = [
  {
    key: "fileNameNotes",
    label: "File Name",
    sortable: false,
    style: { width: "25%" },
  },
  {
    key: "Notes_description",
    label: "Note",
    sortable: false,
    style: { width: "65%" },
    //   style: {width: '15%'},
  },

  {
    key: "downloadFile",
    label: "Action",
    style: { width: "10%", textAlign: "center" },

    //style: {width: '6%'},
  },
];

export const ExportActivityHeader: Header[] = [
  {
    key: "activitySummary",
    label: "Activity Stage",
    style: { width: "160px" },
  },
  {
    key: "addedBy",
    label: "Added By",
    style: { width: "150px" },
  },
  {
    key: "transactionDate",
    label: "Transaction Date & Time",
    style: { width: "200px" },
  },
  {
    key: "elapsedTime",
    label: "Elapsed Time",
    style: { width: "130px" },
  },
  {
    key: "activityDescription",
    label: "Activity Description",
  },
];
